/**
 * Tiny bridge context: avoids circular import between
 * VendorAuthContext (imports VendorAuthModal) and
 * VendorAuthModal (needs callbacks from VendorAuthContext).
 *
 * VendorAuthContext sets this value; VendorAuthModal reads it.
 */
import { createContext } from "react";
export const VendorModalCallbacks = createContext(null);
